import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Color from 'color'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { flexUtils, palette } from '../../Theme/Theme'
import * as Actions from '../../Actions/Actions'
import { CSSTransitionGroup } from 'react-transition-group' // ES6
import { Link } from 'react-router-dom'
// import ReactGA from 'react-ga'
// import Responsive from 'react-responsive'
import ShowView from '../Home/Shows/ShowView'
import back from '../../../assets/close.png'

// const Desktop = props => <Responsive {...props} minWidth={736}/>
// const Mobile = props => <Responsive {...props} maxWidth={735}/>

class Home extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isHeroShown: true
    }
    this.playShow = this.playShow.bind(this)
  }
  render () {
    const { classes, match } = this.props
    const { Body } = classes
    return (
      <React.Fragment>
        <img src="../../../Assets/flat_grid_bright.png" alt='' className={classes.Image}/>
        <div className={Body}>
          <div className={classes.Header}>
            { this.renderLogo() }
            <div>
              <Link style={{zIndex: '100'}} className={classes.NavButton} to={'/welcome/signin'}>Sign In</Link>
              <Link className={classes.NavButton} to={'/welcome/signup/userInfo'}>Sign Up</Link>
            </div>
          </div>
          {this.props.libraryState.pending && this.props.loggedUserState.logged ? this.loading() : this.library()}
          <CSSTransitionGroup
            transitionName={{
              enter: classes.enter,
              enterActive: classes.active,
              leave: classes.leave,
              leaveActive: classes.leaveActive
            }}
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}
          >
            {this.state.isHeroShown && this.props.content != null ? this.returnHero() : null}
          </CSSTransitionGroup>
        </div>
      </React.Fragment>
    )
  }

  returnHero () {
    const { classes, content } = this.props
    // console.log(this.props.content)
    return (
      <div onClick={() => { this.showHero(null) }} className={classes.hero}>
        <div className={classes.textContainer}>
          <div className={classes.infoControlsContainer}>
            <div className={classes.backContainer}>
              <img src={back} className={classes.img} alt=""/> Keep Searching
            </div>
            <div className={classes.title}>
              {content.caption}
            </div>
            <div className={classes.description}>
              {content.description}
            </div>
            {this.returnButtons()}
          </div>
        </div>
        <div className={classes.imgContainer}>
          <img className={classes.heroImg} src={content.heroImageUrl}/>
        </div>
      </div>
    )
  }

  returnButtons () {
    const {classes, content, library} = this.props
    if (library.quality !== 'None') {
      return (
        <div className={classes.buttonContainer}>
          <div onClick={() => { this.playShow(false) }} className={classes.button}>
            Play
          </div>
          {content.progress !== 0 ? <div onClick={() => { this.playShow(true) }} className={classes.button}>Resume</div> : null}
        </div>
      )
    } else {
      return (
        <div className={classes.buttonContainer}>
          <Link to="/welcome/signup/userInfo" style={{width: '100%', fontSize: '1.2rem', textDecoration: 'none'}} className={classes.button}>
            Subscribe to Access this Content
          </Link>
        </div>
      )
    }
  }

  renderLogo () {
    const { classes } = this.props
    return (
      <Link to="/welcome" className={classes.imgContainer}>
        <img src="../../../Assets/spectiv_light_medium.png" className={classes.logoSmall} alt=''/>
      </Link>
    )
  }

  playShow (isResumed) {
    if (isResumed) {
      this.props.dispatch(Actions.ChooseShow(this.props.content.h264URL, this.props.content.caption, this.props.content.id, this.props.content.progress))
    } else {
      this.props.dispatch(Actions.ChooseShow(this.props.content.h264URL, this.props.content.caption, this.props.content.id, 0))
    }
    this.props.history.push('/Home/Show')
  }

  showHero (content) {
    this.props.dispatch(Actions.ChooseHero(content))
  }

  loading () {
    const { classes } = this.props
    return (
      <div className={classes.loading}>
        Loading Library...
      </div>
    )
  }

  library () {
    const { classes } = this.props
    return (
      <div className={classes.LibraryBody}>
        {
          this.props.library.view.map((view, index) => {
            return <ShowView view={view} key={index}/>
          })
        }
      </div>
    )
  }

  componentDidMount () {
    this.props.dispatch(Actions.getLibrary())
  }
}

const styles = {
  ...flexUtils,
  enter: {
    opacity: '0'
  },
  active: {
    opacity: '1',
    transition: 'opacity .3s'
  },
  leave: {
    opacity: '1'
  },
  leaveActive: {
    opacity: '0',
    transition: 'opacity .3s'
  },
  heroImg: {
    width: '100vw'
  },
  LibraryBody: {
    marginTop: '8vh'
  },
  backContainer: {
    width: '100%',
    marginTop: '.5vh',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    fontSize: '1.5rem',
    fontWeight: '600',
    '&:hover': {
      cursor: 'pointer'
    }
  },

  img: {
    width: '1.5vw',
    marginRight: '1rem',
    marginLeft: '1rem'
  },
  Body: {
    position: 'absolute',
    top: '0',
    composes: ['$FlexColumn'],
    justifyContent: 'center',
    alignItems: 'center',
    flex: '1',
    minHeight: '70vh',
    minWidth: '100vw',
    // backgroundColor: 'rgb(22,22,22)'
    background: `linear-gradient(45deg, ${Color(palette.pink).darken(0.7).alpha(0.9)}, ${Color(palette.purple).darken(0.7).alpha(0.9)}, ${Color(palette.blue).darken(0.7).alpha(0.9)}, ${Color(palette.teal).darken(0.7).alpha(0.9)})`
  },
  Image: {
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    top: '0',
    left: '0',
    filter: 'blur(20px)'
    // zIndex: '',
  },
  textContainer: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'left',
    flexDirection: 'column',
    zIndex: '1',
    color: palette.white,
    top: '8.5vh',
    width: '100vw',
    height: '91.5vh'
    // backgroundColor: 'red'
  },
  buttonContainer: {
    marginTop: '5rem',
    // backgroundColor: 'red',
    width: '80%',
    display: 'flex',
    marginRight: '15%',
    justifyContent: 'space-around',
    flexDirection: 'row'
  },
  button: {
    borderRadius: '5px',
    transition: 'all .4s',
    width: '10rem',
    height: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.5rem',
    fontWeight: '600',
    color: palette.white,
    backgroundColor: palette.blue,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: Color(palette.blue).darken(0.3).toString()
    }
  },
  infoControlsContainer: {
    width: '31vw',
    // backgroundColor: 'red',
    height: '27vw',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '-8.6vh'
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: '600',
    width: '90%',
    // backgroundColor: 'blue',
    paddingTop: '2.5vw'
  },
  description: {
    width: '90%',
    fontSize: '1.5rem',
    paddingTop: '2vw'
  },
  imgContainer: {
    // marginTop: '-8.5vh'
  },
  hero: {
    // animation: 'fadein .7s',
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: '0',
    left: '0',
    zIndex: '2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: Color('rgba(22,22,22)').alpha(0.7).toString()
  },
  loading: {
    fontSize: '3rem',
    color: palette.white
  },
  NavButton: {
    textAlign: 'center',
    display: 'inline-block',
    textDecoration: 'none',
    lineHeight: '2.4rem',
    width: '6rem',
    height: '2.4rem',
    borderRadius: '5px',
    margin: '.5rem',
    color: 'rgb(230, 230, 230)',
    fontSize: '1.3rem',
    fontWeight: '500',
    transition: 'all .3s',
    '&:hover': {
      color: palette.blue
    }
  },
  NavButtonMobile: {
    extend: 'NavButton',
    width: '5rem',
    fontSize: '1rem'
  },
  logoSmall: {
    width: '9vw',
    transition: 'all .4s',
    margin: '.5rem',
    minWidth: '8rem'
  },
  Header: {
    composes: ['$FlexRow'],
    padding: '.5rem',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '8vh',
    width: '100vw',
    position: 'fixed',
    top: '0',
    left: '0',
    backgroundColor: 'rgba(22,22,22,0.8)',
    zIndex: '1000'
  }
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    libraryState: state.mainState.libraryState,
    library: state.mainState.library,
    content: state.mainState.content,
    loggedUserState: state.mainState.loggedUserState
  }
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(Home)))



// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/Browse.jsx